import { createAction } from '@ngrx/store';

export enum RequestCounterAction {
  IncrementCounter = '[Request Counter] Increment Counter',
  DecrementCounter = '[Request Counter] Decrement Counter',
}

const incrementCounter = createAction(RequestCounterAction.IncrementCounter);
const decrementCounter = createAction(RequestCounterAction.DecrementCounter);

const requestCounterAction = {
  incrementCounter,
  decrementCounter,
};

export default requestCounterAction;
